import PropTypes from "prop-types";
import { slugify } from "../../../utils";

const ProjectFilter = ({ categories }) => {
    return (
        <div className="filter-menu">
            <ul className="menu-list">
                <li>
                    <button data-filter="*" className="active">
                        All
                    </button>
                </li>
                {categories?.map((cat, idx) => (
                    <li key={idx}>
                        <button data-filter={`.${slugify(cat)}`}>{cat}</button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

ProjectFilter.propTypes = {
    categories: PropTypes.array,
};

export default ProjectFilter;
